import { useDispatch, useSelector } from 'react-redux';

// selectors
import * as tradeInsSelectors from '@makemydeal/dr-dash-store/selectors/tradeIns';
import * as tradeInsActionCreators from '@makemydeal/dr-dash-store/actions/tradeInsActionCreators';
import { useSingleTradeInFormProvider } from '../MultiTradeIn/TradeInFormProvider';

// libraries
import { kebabCase } from '@makemydeal/dr-common-utils';

// constants
import { INTERIOR_COLOR, ZERO_WIDTH_SPACE } from '../../../constants';

// components
import { TextInput } from '@makemydeal/dr-shared-components/text-input';
import { Typography } from '@interstate/components/Typography';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

// styling
import { DetailContainer } from '../trade.style';

interface InteriorColorFieldProps {
    hasTradeIn: boolean;
    isManualFormOpen: boolean;
    disabled?: boolean;
}

export const InteriorColorField: React.FC<InteriorColorFieldProps> = ({ hasTradeIn, isManualFormOpen, disabled }) => {
    const dispatch = useDispatch();
    const { tradeInIndex } = useSingleTradeInFormProvider();
    const interiorColor = useSelector(tradeInsSelectors.getInteriorColor(tradeInIndex));

    const onChange = (event: any) => {
        dispatch(tradeInsActionCreators.updateTradeInInteriorColor(event.target.value, tradeInIndex));
    };

    return (
        <>
            {isManualFormOpen ? (
                <TextInput
                    label={INTERIOR_COLOR}
                    data-testid={kebabCase(INTERIOR_COLOR)}
                    name={kebabCase(INTERIOR_COLOR)}
                    onChange={onChange}
                    value={interiorColor}
                    size="sm"
                    disabled={disabled}
                    selectOnFocusSelector={featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap}
                />
            ) : (
                <>
                    {hasTradeIn && (
                        <DetailContainer>
                            <Typography variant="label-md" color="sem.color.on-surface.muted" sx={{ marginBottom: '8px' }}>
                                {INTERIOR_COLOR}
                            </Typography>
                            <Typography variant="body-md" tag="span" data-testid="trade-interior-color-value-label">
                                {interiorColor || ZERO_WIDTH_SPACE}
                            </Typography>
                        </DetailContainer>
                    )}
                </>
            )}
        </>
    );
};
